import React from 'react'

const Footer = () => {
  return (
    <div className='container'>
      <div className='footer-content'>Design by Micah Bala &bull; 2022</div>
    </div>
  )
}

export default Footer
